// Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved

import { css } from 'emotion';
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { loadOrders, setCount } from '../actions';
import { COLOR } from '../const'
import OrderItem from './OrderItem';
// import axios from 'axios';
import { getOrders } from '../api/githubAPI';
import Modal from './Modal';
import OrderDetail from './OrderDetail';

const OrderList = () => {
  // const [ loadIs, setloadIs ] = useState(true)
  const ordersCount: any = useSelector((state: any) => state.Order.orders.length)
  const { keyword, date, sort, skip } = useSelector((state: any) => state.Search)
  const { sender, box, ordertype } = useSelector((state: any) => state.Filter)
  // const Filter = useSelector((state: any) => state.Filter)
  // console.log(Filter)
  const dispatch = useDispatch();
  
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [reload, setReload] = useState<number>(0)

  const [issuesError, setIssuesError] = useState<Error | null>(null)

  async function fetchEverything() {
    async function fetchOrders() {
      const OrdersResult:any = await getOrders(keyword, date, sort, skip, sender, box, ordertype)
      dispatch(loadOrders(OrdersResult.orders))
      dispatch(setCount(OrdersResult.count))
    }

    try {
      await Promise.all([fetchOrders()])
      setIssuesError(null)
    } catch (err) {
      console.error(err)
      setIssuesError(err)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    setIsLoading(true)
    if(isLoading){
      fetchEverything();
    }
  }, [keyword, date, sort, skip]);

  useEffect(() => {
    setReload(reload + 1);
    fetchEverything();
    
  }, [keyword, date, sort, skip]);

  useEffect(() => {
    setReload(reload + 1);
    fetchEverything();
    
  }, [sender, box, ordertype]);
  
  useEffect(() => {
    const interval = setInterval(() => {
      setReload(reload + 1);
    }, 5000);
    // console.log(reload)
    fetchEverything();
    return () => {
      clearInterval(interval);
    };
  }, [reload]);



  if (issuesError) {
    return (
      <div>
        <h1>Something went wrong...</h1>
        <div>{issuesError.toString()}</div>
      </div>
    )
  }

  let renderedList = isLoading ? (
    <h3>Loading...</h3>
  ) : (
    <div className={styles.divTableBody}>

    {new Array(ordersCount).fill(null).map((_, index:number) => (
      <OrderItem index={index} key={index}/>
    ))}


  </div>
  )

  return (
    <div className={styles.divTable}>
      <div className={styles.divTableHeading} >
        <div className={styles.divTableRow}>
        <div className={styles.divTableCell}>#</div>
          <div className={styles.divTableCell}>TRACKING NO.</div>
          <div className={styles.divTableCell}>PACKAGE</div>
          <div className={styles.divTableCell}>SENDER</div>
          <div className={styles.divTableCell}>COURIER</div>
          <div className={styles.divTableCell}>DELIVERY DATE</div>
          <div className={styles.divTableCell}>TYPE</div>
          <div className={styles.divTableCell}>CONSIEGNEE</div>
          <div className={styles.divTableCell}>MOBILE</div>
        </div>
      </div>
     {renderedList}
     {<Modal>
        <OrderDetail/>
      </Modal>}
    </div>
  )
}

//  const 
// const useOrder = (data:[object]): { loadOrder: () => void } => {


//   const dispatch = useDispatch();
//   const loadOrder: any = useCallback(() => dispatch(loadOrders(data)), [
//     dispatch
//   ]);
//   return { loadOrder };
//   // return todo


// }


// const userLoadOrder = async () => {
//   const orders: any = await axios.request({
//     url: 'http://122.155.201.108:8015/api/orders'
//   }).then((response) => {
//     // console.log(response.data)
//     // `response` is of type `AxiosResponse<ServerData>`
//     const data = response.data
//     console.log(data)
//     return data;
//     // `data` is of type ServerData, correctly inferred
//   }, (error) => {
//     console.log(error);
//   });
//   console.log('orders',orders)
//   return orders;
// }

// const useOrderMemo = (): { loadOrder: () => void } => {


//   const dispatch = useDispatch();
//   const loadOrder: any = useCallback(() => dispatch(loadOrders(true)), [
//     dispatch
//   ]);
//   return { loadOrder };
//   // return todo
// }

const styles = {
  count: css`
    font-size: 12px;
  `,
  lastUpdated: css`
    color: #666;
    font-size: 10px;
  `,
  todos: css`
    padding-left: 0;
  `,
  divTable: css`
    display: table;
    width: 100%;
    `,
  divTableRow: css`
    display: table-row;
    box-shadow: 0px -1px 3px rgba(0, 0, 0, 0.13);
    border-radius: 23px 0px 0px 0px;
    `,
  divTableHeading: css`
    background-color: #ffffff;
    display: table-header-group;
    `,
  divTableCell: css`
    display: table-cell;
    padding: 10px;
    text-align: center;
    font-weight: bold;
    font-size: 18px;
    color: ${COLOR['BLUE_DARK']};
    `,
  divTableHead: css`
    border: 1px solid #999999;
    display: table-cell;
    padding: 3px 10px;
    `,
  divTableBody: css`
      display: table-row-group;
      background-color: #ffffff;
   `,

};
export default OrderList